//= ========================================================================
import React from 'react';
import { ScrollView, View } from 'react-native';
import { Android } from '../../utils/DictionaryManagementUtils';
import BtnElement from '../style/BtnElement';

const ManualMethodsList = ({
  globJSON,
  simPlatform,
  recipient,
}) => {
  const myStyles = {
    viewAll: {
      width: 182,
      height: simPlatform === Android ? 257 : 221,
      marginLeft: 29,
      flexDirection: 'column',
    },
    disableBackground: {
      width: 240,
      height: simPlatform === Android ? 427 : 520,
      position: 'absolute',
      backgroundColor: 'rgba(255,255,255,0.5)',
    },
  };

  return (
    <View>
      <ScrollView
        style={myStyles.viewAll}
        vertical
        pagingEnabled={false}
        showsVerticalScrollIndicator={false}
        scrollEnabled
      >
        {(recipient.screens_ordering
          .filter((manualKey) => recipient.manual_recipients[manualKey].selected)
          .map((manualKey) => (
            <BtnElement
              globJSON={globJSON}
              simPlatform={simPlatform}
              headline={recipient.manual_recipients[manualKey].manual_name}
              key={manualKey}
              isBar
              isSquare={globJSON.configurations.theme.radius.elements_shape_square}
            />
          )))}
      </ScrollView>
    </View>
  );
};
export default ManualMethodsList;
